import { usePathsV2 } from 'core/services/navigation/usePathsV2';
import { CandidateProfileDetail } from 'modules/candidate-profile/components/CandidateProfileDetail';
import { CandidateProfileDetailType } from 'modules/candidate-profile/types/CandidateProfileDetailProps';

export const AnalyseCandidateProfileDetailsPage: React.FC = () => {
  const { getPathParams } = usePathsV2();
  const { candidateBatchId, candidateProfileId } =
    getPathParams.ANALYSE_CANDIDATE_PROFILE_DETAILS();

  return (
    <CandidateProfileDetail
      type={CandidateProfileDetailType.ANALYSE_CANDIDATE_PROFILE_DETAILS}
      candidateProfileId={candidateProfileId}
      candidateBatchId={candidateBatchId}
    />
  );
};
